import { useTheme } from "@mui/system";

export default function FDocIcon({ size = 20 }) {
  const theme = useTheme();

  const baseWidth = 20;
  const baseHeight = 20;

  const height = (baseHeight * size) / baseWidth;

  return (
    <svg
      width={baseWidth}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Лист документа */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 2.5C3 1.11929 4.11929 0 5.5 0H11.0858C11.351 0 11.6054 0.105357 11.7929 0.292893L16.7071 5.20711C16.8946 5.39464 17 5.649 17 5.91421V17.5C17 18.8807 15.8807 20 14.5 20H5.5C4.11929 20 3 18.8807 3 17.5V2.5ZM5.5 1.5C4.94772 1.5 4.5 1.94772 4.5 2.5V17.5C4.5 18.0523 4.94772 18.5 5.5 18.5H14.5C15.0523 18.5 15.5 18.0523 15.5 17.5V6.5H12C11.4477 6.5 11 6.05228 11 5.5V1.5H5.5ZM12.5 2.56066L14.4393 4.5H12.5V2.56066Z"
        fill={theme.palette.rgd.primary}
      />
      {/* Строки текста */}
      <path
        d="M6.75 9.25H13.25V10.5H6.75V9.25ZM6.75 12.25H13.25V13.5H6.75V12.25ZM6.75 15.25H10.75V16.5H6.75V15.25Z"
        fill={theme.palette.rgd.primary}
      />
    </svg>
  );
}
